import Data from "../Data";
import "../Taketour.css";
import StyleItem from "../StyleItem";
import heroChats from "../../../../assets/images/hero-chat.png"

const Chat = (props) => {
  const { chatData } = Data();
  return (
    <div>
      {chatData.map((item, index) => (
        <StyleItem key={index} data={item} />
      ))}
      <div className="taketour-image-section">
        <img src={heroChats} alt="" />
      </div>
    </div>
  );
};

export default Chat;
